export class GetMyEventInvitationsAction {
  static readonly type = '[EventInvitations] Get My Invitations';
}

export class AcceptEventInvitationAction {
  static readonly type = '[EventInvitations] Accept Invitation';
  constructor(public eventId: string) {}
}

export class DeclineEventInvitationAction {
  static readonly type = '[EventInvitations] Decline Invitation';
  constructor(public eventId: string) {}
}

export class RemoveEventFromInvitationsAction {
  static readonly type = '[EventInvitations] Remove From List';
  constructor(public eventId: string) {}
}
